import { BreakpointObserver } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Inject,
  Input,
  PLATFORM_ID,
  DOCUMENT
} from '@angular/core';
import { GlobalDataService } from '@app/core/services/global-data.service';
import { Component as Page } from '@bloomreach/spa-sdk';
import { breakpoints, ThemeTypes } from '@shared/constants';

declare let hbspt: any;
@Component({
    selector: 'mflooring-footer-menu-mobile',
    templateUrl: './footer-menu-mobile.component.html',
    styleUrls: ['./footer-menu-mobile.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FooterMenuMobileComponent implements AfterViewInit {
	@Input() menu: any;
	@Input() page: Page;
	@Input() footerData: any;
	hubSpotLoaded: boolean = false;
	hubspotData:any

	get theme() {
		return ThemeTypes.dark;
	}

	get socialIcons(): any[] {
		return (
			!!this.footerData?.socialMedia &&
			Object.entries(this.footerData?.socialMedia)
				.map((entry: any) => {
					return {
						name: entry[1].classname,
						imgUrl: entry[1].imgUrl,
						url: entry[1].url,
						order: entry[1].order,
					};
				})
				.sort((a: any, b: any) => {
					return a.order - b.order;
				})
		);
	}

	get logoPresentation() {
		return {
			theme: this.theme,
		};
	}

	get logoContent() {
		return this.footerData.logo;
	}
	public isMobile: boolean;
	constructor(
		private breakpoint: BreakpointObserver,
		@Inject(DOCUMENT) private documentRef: Document,
		@Inject(PLATFORM_ID) private platformId: string,
		private globalDataServices: GlobalDataService
	) {
		this.isMobile = this.breakpoint.isMatched(breakpoints.mobileMaxfooter);
	}
	@HostListener('window:resize') onResize() {
		this.isMobile = this.breakpoint.isMatched(breakpoints.mobileMaxfooter);

		return this.isMobile;
	}
	ngAfterViewInit(): void {
		this.hubspotData = this.globalDataServices.getGlobalData();
		// if (isPlatformBrowser(this.platformId)) {
		// 	let time = 5500;
		// 	let content = this.documentRef.querySelector(
		// 		`script[src="//js.hsforms.net/forms/embed/v2.js"`
		// 	);

		// 	if (content) {
		// 		time = 500;
		// 	}
		// 	setTimeout(() => {
		// 		let hubspotData = this.globalDataServices.getGlobalData();
		// 		this.hubSpotLoaded = true;
		// 		hbspt?.forms?.create({
		// 			region: 'na1',
		// 			portalId: hubspotData?.['mf.hubspot.portalId'] ?? '152354',
		// 			formId: hubspotData?.['mf.hubspot.footer.formId'] ?? 'c2065635-57a0-4ae2-955a-4f2eca69c031',

		// 			target: '#hubspotForm',
		// 			css: '',
		// 			cssClass: 'my-hubspot-form',
		// 		});
		// 	}, time);
		// }
	}

	public trackBy(index: number, el: any) {
		return el.name;
	}
}
